module.exports = __webpack_public_path__ + "img/bonteous_slide_1.887a5855.jpg";